import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import FormGroup from '../../../../../../../components/global/FormGroup';
import { CARD_BORDER_TYPE } from '../../../../../../../services/cards/constants';

const propTypes = {
  className: PropTypes.string,
  elementConfiguration: PropTypes.shape({
    element: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
    configuration: PropTypes.shape({
      border: PropTypes.shape({
        type: PropTypes.string,
        width: PropTypes.number,
        color: PropTypes.string,
        opacity: PropTypes.number,
      }),
      rectangle_element_configuration: PropTypes.shape({
        color: PropTypes.string,
        opacity: PropTypes.number,
      }),
    }).isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};

const CardRectangleElementConfiguration = ({
  className,
  elementConfiguration,
  onChange,
}) => {
  const classes = classNames({
    'card-element-configuration': true,
    'card-rectangle-element-configuration': true,
    [className]: !!className,
  });

  const { element, configuration } = elementConfiguration;

  return (
    <div className={classes}>
      <h3 className="card-element-configuration-type">{element.type}</h3>

      <FormGroup
        id={`${element.id}-border-color`}
        placeholder="Border Color"
        label="Border Color"
        labelSrOnly
        size="sm"
        className="m-0"
        value={configuration.border?.color || ''}
        onChange={event => {
          const { value } = event.target;

          if (value) {
            onChange({
              // TODO [cards] hardcoded border sizes for the back for WG 1.2
              border: {
                color: value,
                type: CARD_BORDER_TYPE.SOLID,
                width: 0.026,
                opacity: 1,
              },
              is_editable: false,
            });
          } else {
            onChange({
              border: undefined,
              is_editable: undefined,
            });
          }
        }}
      />

      <pre className="card-element-configuration-metadata">
        <p>z-index: {element.z_index}</p>
      </pre>
    </div>
  );
};

CardRectangleElementConfiguration.propTypes = propTypes;

export default CardRectangleElementConfiguration;
